import React from 'react'
import { connect } from 'react-redux'

class WinnerList extends React.Component {
    shouldComponentUpdate() {
        return true
    }

    render() {
        const vl = this.props.data
        if (this.props.userInfo === null) return ''
        return (
            <div className="winners">
                <div className="TitLine">
                    <b>별명</b>
                    <b>이름</b>
                    {vl.length > 1 && (
                        <React.Fragment>
                            <b>별명</b>
                            <b>이름</b>
                        </React.Fragment>
                    )}
                </div>
                <div className="wUsers">
                    {vl.map((v, i) => {
                        const myWin = this.props.userInfo.user_idx === v.idx_member
                        const key = i
                        return (
                            <React.Fragment key={key}>
                                <font className={myWin ? 'me' : 'you'}>
                                    {myWin && (
                                        <img
                                            src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/ico_event_is_win2.png`}
                                            alt="당첨"
                                        />
                                    )}
                                    {v.nm_nick} / {v.memberID}
                                </font>
                                <font className={myWin ? 'me' : 'you'}>{v.memberName ? v.memberName : v.memberID}</font>
                            </React.Fragment>
                        )
                    })}
                </div>
            </div>
        )
    }
}
const stateData = state => {
    return {
        userInfo: state.user.userInfo,
    }
}
export default connect(stateData)(WinnerList)
